export const labelStyle =
    // twMerge(
    "flex-1 py-[11px] text-center border-box rounded-[8px] text-[#4B632B] border border-transparent has-[:checked]:bg-white has-[:checked]:border-primary2 has-[:checked]:shadow-custom has-[:checked]:text-[#484964]";
// );

type Props = {
    categoryName: string;
    categoryTabs: { label: string; value: string }[];
};

export default function CategoryTab({ categoryName, categoryTabs }: Props) {
    return (
        <div role="group" className="bg-primary3 rounded-[8px] p-[4px] flex">
            {categoryTabs.map((tab, index) => {
                return (
                    <label key={index} className={labelStyle}>
                        <input type="radio" name={categoryName} value={tab.value} className="appearance-none" />
                        {tab.label}
                    </label>
                );
            })}
        </div>
    );
}
